export default "__VITE_ASSET__CXiMizz3__"